<template>
    <div id="loading" @touchmove.prevent v-show="visible">
        <div class="box">
            <img src="../../assets/images/loading.gif" alt="">
            <div>加载中...</div>
        </div>
    </div>
</template>

<script>
    export default {
        components:{

        },
        data() {
            return {
                visible: false
            }
        },
        methods: {
            
        },
    }
</script>

<style lang="less" scoped>
    #loading{
        position:fixed;
        left:0;
        top:0;
        width:100%;
        height:100%;
        z-index:10;
        background:rgba(127,127,127,.0);
        .box{
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translate(-50%,-50%);
            width: 120px;
            height: 120px;
            background: rgba(0,0,0,.5);
            border-radius: 10px;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            img{
                width: 32px;
                height: 32px;
            }
            div{
                color: #FFFFFF;
                margin-top: 20px;
                font-size: 16px;
            }
        }
    }
</style>